<template>
	<input
		id="toggle"
		class="toggle"
		v-bind:class="{
			toggle: settings.themeV2.dark,
			checked: !settings.themeV2.dark,
		}"
		type="checkbox"
		@click="changeTheme(settings)"
		v-model="settings.themeV2.dark"
	/>
</template>
<script>
export default {
	computed: {
		settings() {
			return this.$store.getters["settings/settings"];
		},
	},

	methods: {
		changeTheme(settings) {
			let vm = this;

			this.analyticsTrack("general", "theme", {
				mode_selected: settings.themeV2.dark ? "dark" : "light",
			});

			vm.$store.commit("settings/changeTheme");
		},
	},
};
</script>
<style lang="scss">
// magic
.toggle {
	--size: 14px;
	appearance: none;
	outline: none;
	cursor: pointer;
	background: none;
	width: var(--size);
	height: var(--size);
	box-shadow: inset calc(var(--size) * 0.33) calc(var(--size) * -0.25) 0;
	border-radius: 50%;
	color: var(--dark-blue);
	border: none;

	transition: all 500ms;
}
.checked {
	--ray-size: -5.5px;
	--offset-orthogonal: calc(var(--size) * 0.78);
	--offset-diagonal: calc(var(--size) * 0.55);
	transform: rotate(287deg);
	color: hsl(40, 100%, 50%);
	box-shadow:
		inset 0 0 0 var(--size),
		calc(var(--offset-orthogonal) * -1) 0 0 var(--ray-size),
		var(--offset-orthogonal) 0 0 var(--ray-size),
		0 calc(var(--offset-orthogonal) * -1) 0 var(--ray-size),
		0 var(--offset-orthogonal) 0 var(--ray-size),
		calc(var(--offset-diagonal) * -1) calc(var(--offset-diagonal) * -1) 0
			var(--ray-size),
		var(--offset-diagonal) var(--offset-diagonal) 0 var(--ray-size),
		calc(var(--offset-diagonal) * -1) var(--offset-diagonal) 0 var(--ray-size),
		var(--offset-diagonal) calc(var(--offset-diagonal) * -1) 0 var(--ray-size);
}

.toggle {
	&:checked {
		& ~ .background {
			--bg: white;
		}
		& ~ .title {
			--color: hsl(40, 100%, 50%);
		}
	}
}
</style>
